import { makeApiUrl, makeHttpClient } from '~/main/factories/http';
import { UpdateOrgUnit as UseCaseRemoteUpdateOrgUnit } from '~/domain/usecases/orgUnit/remote';

import { RemoteUpdateOrgUnit } from '~/data/repository/orgUnit';

export const makeRemoteUpdateOrgUnit = (): UseCaseRemoteUpdateOrgUnit =>
  new RemoteUpdateOrgUnit(makeApiUrl('/orgUnits'), makeHttpClient());
